import React from 'react';

export const IconPointsVertical = () => (
  <svg width="4px" height="18px" viewBox="0 0 4 18" version="1.1">
    <title>icon-overflow2-18px</title>
    <desc>Created with Sketch.</desc>
    <g id="Functional-Icons" stroke="none" fill="none">
      <g id="icon-overflow2-18px" transform="translate(-7.000000, 0.000000)">
        <polygon id="bounds" points="0 0 18 0 18 18 0 18" />
        <g
          id="More"
          transform={[
            'translate(9.000000, 9.000000) rotate(-270.000000) ',
            'translate(-9.000000, -9.000000) translate(0.000000, 7.000000)'
          ].join(' ')}
          fill="#333333"
        >
          <path
            d="M16,4 C14.896,4 14,3.104 14,2 C14,0.895 14.896,0 16,0 C17.104,0 18,0.895 18,2 C18,3.104 17.104,4 16,4 Z"
            id="Stroke-1"
          />
          <path
            d="M9,4 C7.896,4 7,3.104 7,2 C7,0.895 7.896,0 9,0 C10.104,0 11,0.895 11,2 C11,3.104 10.104,4 9,4 Z"
            id="Stroke-3"
          />
          <path
            d="M2,4 C0.896,4 0,3.104 0,2 C0,0.895 0.896,0 2,0 C3.104,0 4,0.895 4,2 C4,3.104 3.104,4 2,4 Z"
            id="Stroke-5"
          />
        </g>
      </g>
    </g>
  </svg>
);
